import React, { useState, useEffect } from 'react';
import { Institution } from '../../../lib/supabase';
import { useAdminStore } from '../../../lib/store-admin';

interface InstitutionModalProps {
    isOpen: boolean;
    onClose: () => void;
    institution?: Institution;
}

export const InstitutionModal: React.FC<InstitutionModalProps> = ({ isOpen, onClose, institution }) => {
    const { addInstitution, updateInstitution, isLoading } = useAdminStore();
    const [name, setName] = useState('');
    const [logoFile, setLogoFile] = useState<File | null>(null);
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (institution) {
            setName(institution.name);
            setPreviewUrl(institution.logo_url || null);
        } else {
            setName('');
            setPreviewUrl(null);
        }
        setLogoFile(null);
        setError(null);
    }, [institution]);

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            setLogoFile(file);
            const objectUrl = URL.createObjectURL(file);
            setPreviewUrl(objectUrl);
        }
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError(null);

        if (!name.trim()) {
            setError('Kurum adı gereklidir.');
            return;
        }

        let result;
        if (institution) {
            result = await updateInstitution(institution.id, { name }, logoFile || undefined);
        } else {
            result = await addInstitution(name, logoFile || undefined);
        }

        if (result.success) {
            onClose();
        } else {
            setError(result.error || 'Bir hata oluştu.');
        }
    };

    if (!isOpen) return null;

    return (
        <div className="profile-settings-overlay">
            <div className="profile-settings-modal">
                <h2>{institution ? 'Kurumu Düzenle' : 'Yeni Kurum Ekle'}</h2>

                <form onSubmit={handleSubmit}>
                    <div className="avatar-upload-section">
                        <div className="institution-logo-preview" style={{ width: '120px', height: '80px', background: '#f3f4f6', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                            {previewUrl ? (
                                <img src={previewUrl} alt="Logo Preview" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                            ) : (
                                <span className="material-symbols-outlined" style={{ fontSize: '32px', color: '#d1d5db' }}>image</span>
                            )}
                        </div>
                        <label className="upload-btn">
                            <span className="material-symbols-outlined">upload</span>
                            Logo Yükle
                            <input
                                type="file"
                                hidden
                                accept="image/*"
                                onChange={handleFileChange}
                            />
                        </label>
                    </div>

                    <div className="form-group">
                        <label>Kurum Adı</label>
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Örn: Saletone A.Ş."
                            disabled={isLoading}
                        />
                    </div>

                    {error && (
                        <div className="error-message" style={{ color: '#ef4444', fontSize: '14px', marginTop: '10px' }}>
                            {error}
                        </div>
                    )}

                    <div className="modal-actions">
                        <button type="button" className="btn-cancel" onClick={onClose} disabled={isLoading}>
                            İptal
                        </button>
                        <button type="submit" className="btn-save" disabled={isLoading}>
                            {isLoading ? 'Kaydediliyor...' : 'Kaydet'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
